import { hot } from 'react-hot-loader/root'; //als eerste

import React, { StrictMode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Cookies from 'js-cookie';

import PageHeader from "./layout/PageHeader";
import PageContent from "./layout/PageContent";
import ExceptionPage from "./exception/ExceptionPage";
import SideNav from "./layout/SideNav";
import Beads from "./layout/Beads";
import generateGuid from "../util/guid";
import ConfirmModal from "./common/ConfirmModal";
import { Dimmer, Modal } from "semantic-ui-react";
import Loader from "./common/Loader";
import CheckBoxWithChild from "./common/CheckBoxWithChild";
import Fieldset from "./common/Fieldset";
import Row from "./common/Row";
import { PortaalTeksten } from "../constants/DomainConstants";
import moment from 'moment';

import { getRoutes } from "../components/Navigation";

class App extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			cookieChecked: false,
			showStatusPopup: false,
			termsAccepted: false,
			termsAcceptedBox: false
		};
	}

	componentDidUpdate() {
		if (this.props.portaalTeksten && this.props.portaalTeksten.length && !this.state.termsAccepted && !this.state.cookieChecked) {
			let termsAccepted = false;
			let cookie = Cookies.get('nadotermsaccepted');
			let nadoTermsAcceptedCookie = cookie ? JSON.parse(Cookies.get('nadotermsaccepted')) : null;
			const disclaimerLastUdatedOn = this.props.portaalTeksten.find(t => t.label.naam == PortaalTeksten.DISCLAIMER_HTML).label.lastModifiedOn;

			if (nadoTermsAcceptedCookie) {
				const expiryDate = moment(nadoTermsAcceptedCookie.lastVisitOn).add(30, 'days');
				if (expiryDate > moment()
					&& nadoTermsAcceptedCookie.disclaimerLastUpdatedOn === disclaimerLastUdatedOn)
					termsAccepted = true;
			}

			this.setState({ termsAccepted: termsAccepted, cookieChecked: true });
		}
	}

	onClickAcceptTerms = () => {
		const portaalText = this.props.portaalTeksten.find(t => t.label.naam == PortaalTeksten.DISCLAIMER_HTML);
		const disclaimerLastUdatedOn = portaalText.label.lastModifiedOn;

		Cookies.set(
			'nadotermsaccepted',
			JSON.stringify({ accepted: true, disclaimerLastUpdatedOn: disclaimerLastUdatedOn, lastVisitOn: moment() }),
			{ expires: 30 }
		);

		this.setState({ termsAccepted: true });
	};

	onClickStatusButton = () => {
		this.setState({
			showStatusPopup: true
		});
		window.parent.scrollTo(0, 10);
	};

	confirmStatusPopup = () => {
		this.setState({
			showStatusPopup: false
		});
	};

	onChanceTermsAcceptBox = (e) => {
		this.setState({ termsAcceptedBox: e.target.checked });
	};

	render() {
		const { portaalTeksten, showHeader, showTopNav, showSimpleTopNav, disableSimpleTopNav, showSideNav, showBeads, loading, pageHeaderTitle, pageHeaderSubtitle, exception, topNavTabSettings, scope, match, accountId, accountType } = this.props;
		const { termsAccepted, termsAcceptedBox, cookieChecked } = this.state;

		const disclaimerHtmlItem = portaalTeksten ? portaalTeksten.find(t => t.label.naam == PortaalTeksten.DISCLAIMER_HTML) : null;
		return (
			// <StrictMode>
			<div>
				{!termsAccepted && cookieChecked && <ConfirmModal
					showOnTop
					isOpen={!termsAccepted}
					mainText={<Fieldset>
						<p dangerouslySetInnerHTML={{ __html: disclaimerHtmlItem ? disclaimerHtmlItem.label.portaalTekst : '' }} />
						<br />
						<Row>
							<CheckBoxWithChild
								name="termsAcceptedBox"
								label="Ik ga akkoord met bovenstaande voorwaarden en bepalingen."
								value={termsAcceptedBox}
								onChange={(event) => this.onChanceTermsAcceptBox(event)}
							/></Row>
					</Fieldset>}
					confirmAction={this.onClickAcceptTerms}
					confirmText="Verder"
					disableConfirm={!termsAcceptedBox
					}
				/>}
				<ExceptionPage exception={exception}>
					<Dimmer active={loading} page><Loader /></Dimmer>
					{showHeader ? <PageHeader showSimpleTopNav={showSimpleTopNav} disableSimpleTopNav={disableSimpleTopNav} showTopNav={showTopNav} title={pageHeaderTitle} intro={pageHeaderSubtitle} topNavTabSettings={topNavTabSettings} scope={scope} accountId={accountId} accountType={accountType} /> : null}
					<PageContent id="modal-holder_pageconten" loading={loading}>
						{showSideNav ? <SideNav key={generateGuid()} accountId={accountId} accountType={accountType} /> : null}
						{showBeads ? <Beads state={this.state} onClickStatusButton={this.onClickStatusButton} confirmStatusPopup={this.confirmStatusPopup} showStatusPopup={this.state.showStatusPopup} /> : null}
						{termsAccepted && getRoutes(match)}
					</PageContent>
					<div id="modal-holder"></div>
				</ExceptionPage>
			</div >
			// </StrictMode>
		);
	}
}

App.propTypes = {
	loading: PropTypes.bool.isRequired,
	showHeader: PropTypes.bool.isRequired,
	showTopNav: PropTypes.bool.isRequired,
	showSimpleTopNav: PropTypes.bool.isRequired,
	disableSimpleTopNav: PropTypes.bool.isRequired,
	topNavTabSettings: PropTypes.object.isRequired,
	showSideNav: PropTypes.bool.isRequired,
	showBeads: PropTypes.bool.isRequired,
	pageHeaderSubtitle: PropTypes.string,
	pageHeaderTitle: PropTypes.string.isRequired,
	exception: PropTypes.object,
	scope: PropTypes.string.isRequired,
	match: PropTypes.object.isRequired,
	accountId: PropTypes.string,
	accountType: PropTypes.string
};

function mapStateToProps(state, ownProps) {
	return {
		portaalTeksten: state.referentie.portaalTeksten,
		loading: state.ajaxCounter > 0,
		showHeader: state.layout.showHeader,
		showTopNav: state.layout.showTopNav,
		showSimpleTopNav: state.layout.showSimpleTopNav,
		disableSimpleTopNav: state.layout.disableSimpleTopNav,
		topNavTabSettings: state.layout.showSportkampenLayout ? state.layout.sportkampenTopNavTabSettings : state.layout.topNavTabSettings,
		showSideNav: state.layout.showSideNav,
		showBeads: state.layout.showBeads,
		pageHeaderTitle: state.layout.pageHeaderTitle,
		pageHeaderSubtitle: state.layout.pageHeaderSubtitle,
		exception: state.exception,
		scope: state.layout.scope,
		accountId: state.settings.accountId,
		accountType: state.settings.accountType,
		validatieStatussen: state.validatieStatussen
	};
}

export default hot(connect(mapStateToProps)(App));